import React from "react";

export default function Banner() {
  return (
    <div>
      {/* <img className="bannerImg" src="/cover_image_withoutext.jpg"></img> */}
      <div className="bannerdiv">
        <div className="bannercaption">
          <span>கனவுகளுக்கும், நிஜங்களுக்கும் இடையே உள்ள இடைவெளியை, </span>
          <br />
          <span>கற்பனையைக் கொண்டு நிரப்புபவன்!</span> <br />
          <span>மைத் துளிகள் தீர்ந்த பிறகும் கூட, எழுதுபவன்!</span> <br />
          <span>
            பக்கங்கள் முடிந்த பிறகும் கூட,
            <br /> வாசிப்பவன்!!! <br />
            <span>- பிரபாகரன்</span>
          </span>
        </div>
      </div>
    </div>
  );
}
